{
  "help": "Помощ",
  "info": "Информация"
}
